import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import Tag from "@/components/base/Tag";

export default function WorkCard({ item }: { item: ContentItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title}｜星空动漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-movie-2-line" />
          {item.format}
        </span>
        {item.rating ? (
          <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-accent-950">
            <i className="ri-star-fill text-[10px]" />
            {item.rating.toFixed(1)}
          </span>
        ) : null}
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          <Tag variant="primary">{item.category}</Tag>
          <Tag variant="secondary">{item.region}</Tag>
          <Tag variant="secondary">{item.year}</Tag>
        </div>
      </div>
    </Link>
  );
}